<!--
@Author: MIYONGLE
@Desc: 选择账号
@Date: 2021-03-02 17时
-->
<template>
  <div class="select-acc-main">
    <div class="select-acc-con">
      <!-- box -->
      <div class="acc-box">
        <!-- logo -->
        <img :src="resOemInfo.webHomeLogo" alt="" class="acc-box-img" />

        <!-- 标题 -->
        <div class="acc-dec">选择账号登录</div>

        <div class="query-item">
          <span class="small-label">下发公司：</span>
          <el-select
            class="el-select-relevant"
            v-model="paramQueryTemp.distributeCompanyId"
            clearable
            filterable
            placeholder="请选择"
            @change="changeCompany"
            @clear="clearParam('distributeCompanyId')"
          >
            <el-option
              v-for="item in resDistributeCompanyList"
              :key="item.id"
              :label="item.companyName"
              :value="item.id"
            ></el-option>
          </el-select>

          <span class="small-label" style="margin-left: 20px;">商户名称：</span>
          <el-select
            class="el-select-relevant"
            v-model="paramQueryTemp.cooperatorId"
            placeholder="请选择"
            clearable
            filterable
            @change="changeCooperator"
            @clear="clearParam('cooperatorId')"
          >
            <el-option
              v-for="item in resAccountCooperatorsList"
              :key="item.userId"
              :label="item.cooperatorName"
              :value="item.cooperatorId"
            >
            </el-option>
          </el-select>
        </div>

        <div class="flex_button">
          <span class="btnLargeFullColor" @click="openModal"
            >批量变更手机号</span
          >
        </div>

        <!-- 表格 -->
        <div id="accTable">
          <el-table
            :data="resDataList"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              :width="commentTableWidth.tableWidth55"
            ></el-table-column>
            <el-table-column label="下发公司" prop="distributeCompanyName">
            </el-table-column>
            <el-table-column label="商户名称" prop="cooperatorName">
            </el-table-column>
            <el-table-column label="商户类型" prop="userTypeDesc">
            </el-table-column>
            <el-table-column label="账号" prop="loginName"> </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span
                  class="btnNoBordeShortrBlue"
                  @click="xhrLoginOpera(scope.row.userId)"
                  >登录</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paramQueryTemp.pageNum"
          :page-sizes="pagination.pageSizeEight"
          :page-size="pagination.pageSize8"
          :layout="pagination.layPagesChange"
          :total="resData.totalCount"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 批量更换手机号弹窗 -->
    <el-dialog
      title="批量变更手机号"
      :visible.sync="dialogVisible"
      @close="resetForm"
      top="0"
    >
      <el-form
        :model="paramFormTemp"
        :rules="rules"
        :label-width="forms.labelMaxWidth"
        ref="paramFormTempRef"
      >
        <el-form-item label="原手机号：">
          <span>{{ resDataInfo.oldPhoneNo }}</span>
        </el-form-item>
        <el-form-item label="变更个数：">
          <span>{{ resDataInfo.num }}</span>
        </el-form-item>
        <el-form-item label="新手机号：" prop="phoneNo">
          <el-input
            placeholder="请输入新手机号"
            v-model="paramFormTemp.phoneNo"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="smsCode">
          <div id="verificationCode">
            <el-input
              placeholder="请输入验证码"
              v-model="paramFormTemp.smsCode"
              clearable
            ></el-input>
            <span class="btnLargeLineColor" @click="xhrGetCodeEvent">{{
              getCode
            }}</span>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">取 消</el-button>
        <button
          class="btnLargeFullColor btnLargeFullColorPadding"
          @click="xhrChangePhone"
        >
          确 定
        </button>
      </div>
    </el-dialog>
    <!-- 提示成功 -->
    <el-dialog
      title="提示"
      :visible.sync="paymentSubmitDialog"
      :before-close="pathLogin"
    >
      <div class="subMitSucceed">
        <span class="succeed-txt">变更成功</span>
        <button
          class="btnLargeFullColor btnLargeFullColorPadding"
          @click="pathLogin"
        >
          重新登陆({{ dataTime }})
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import {
  PAGINATION,
  TABLE_COMMENT_WIDTH,
  FORMS
} from "../../service/businessConsts";
import { HTTP_CODE } from "../../service/axios_constants";
import { setLocal, getLocal, checkNull, delLocal } from "../../filters/filters";
import { getDistributeCompanyList } from "../../mixin/mixincopy";
import { rules } from "./vdt/form_validata";

export default {
  name: "select-acc",
  mixins: [getDistributeCompanyList],
  data() {
    return {
      forms: FORMS,
      commentTableWidth: TABLE_COMMENT_WIDTH,
      pagination: PAGINATION,
      paramQueryTemp: {
        pageNum: 1,
        pageSize: PAGINATION.pageSize8,
        mobile: "",
        distributeCompanyId: "",
        cooperatorId: ""
      },
      paramQuery: {},
      resOemInfo: {},

      resData: {},
      resDataList: [],
      resAccountCooperatorsList: [],
      tableSelectIdList: [],
      dialogVisible: false,
      paymentSubmitDialog: false,
      rules: rules,
      getCode: "获取验证码",
      getCodeTime: 60,
      getCodeDisabled: false, //验证码开关
      paramFormTemp: {
        phoneNo: "",
        smsCode: ""
      },
      resDataInfo: {
        num: "",
        oldPhoneNo: ""
      },
      dataTime: 5,
      setTimeOutFun: null,
      timer: null
    };
  },

  components: {},

  created() {
    this.paramQueryTemp.mobile = !checkNull(JSON.parse(getLocal("userMessage")))
      ? JSON.parse(getLocal("userMessage")).phoneNo
      : this.$route.query.mobile;

    if (!checkNull(getLocal("resOemInfo"))) {
      this.resOemInfo = getLocal("resOemInfo");
    }

    this.clickQuery();
    this.xhrAccountCooperatorsList();
  },

  methods: {
    clickQuery() {
      this.paramQuery = { ...this.paramQueryTemp };
      this.xhrQueryList();
    },

    // 列表
    xhrQueryList() {
      this.$http.postAccList(this.paramQuery).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.resData = res.data;
          this.resDataList = res.data.list;
        }
      });
    },

    // xhr -- 修改手机号
    xhrChangePhone() {
      this.$refs.paramFormTempRef.validate(valid => {
        if (valid) {
          this.$http
            .postChangePhoneExecute({
              phoneNo: this.paramFormTemp.phoneNo,
              smsCode: this.paramFormTemp.smsCode,
              oldPhoneNo: this.resDataInfo.oldPhoneNo,
              userIds: this.tableSelectIdList
            })
            .then(res => {
              if (res.statusCode === HTTP_CODE.suc) {
                this.resetForm();
                // 关闭弹窗给出提示
                this.paymentSubmitDialog = true;
                this.setIntervalTimer();
              }
            });
        }
      });
    },

    // xhr -- 获取验证码
    xhrGetCodeEvent() {
      this.$refs.paramFormTempRef.validateField("phoneNo", valid => {
        // 这里返回空不返回布尔值 checkNull(valid) false 是空值  checkNull(valid) true 为有值
        console.log(checkNull(valid),'???')
        if (checkNull(valid)) {
          if (this.getCodeDisabled) {
            return;
          }

          this.getCodeDisabled = true;
          this.$http
            .postPhoneSendCode({
              phoneNo: this.paramFormTemp.phoneNo
            })
            .then(res => {
              if (res.statusCode === HTTP_CODE.suc) {
                //计时器
                this.timer = setInterval(() => {
                  this.getCodeTime--;
                  this.getCodeDisabled = true;
                  this.getCode = this.getCodeTime + "s";
                  if (this.getCodeTime <= 0) {
                    this.getCode = "获取验证码";
                    this.getCodeDisabled = false;
                    this.getCodeTime = 60;
                    clearInterval(this.timer);
                  }
                }, 1000);
              } else {
                this.getCodeDisabled = false;
              }
            });
        }
      });
    },

    //xhr -- 登录操作 （先退出，再登录）
    xhrLoginOpera(userId) {
      this.$http.postBowOut().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.xhrLogin(userId);
        }
      });
    },

    //xhr -- 登录
    xhrLogin(userId) {
      let param = {
        userId: userId
      };
      this.$http.postAccLogin(param).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          let resData = res.data;
          setLocal("userMessage", JSON.stringify(resData));
          setLocal("Authorization", res.data.sessionToken);
          // setLocal("activeNavIndex", "1");
          delLocal("activeNavIndex");
          this.xhrIsNeedCompleteContractInformation();
        }
      });
    },

    // xhr---是否需呀补全合同信息
    xhrIsNeedCompleteContractInformation() {
      this.$http.getIsNeedCompleteContractInformation().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          // 保存商户费率类型 判断余额管理是否显示管理费退还按钮
          setLocal("computeMode", res.data.computeMode);
          if (
            res.data.need ||
            res.data.signNeed ||
            res.data.supplementarySignNeed
          ) {
            // 这里跳转首页 清除缓存页面 强制去首页
            delLocal("activeNavIndex");
            this.$router.push({ name: "index" });
            window.location.reload();
          } else {
            //登陆成功跳转首页
            this.$router.push({ name: "index" });
            window.location.reload();
          }
        }
      });
    },

    // xhr -- 商户列表
    xhrAccountCooperatorsList() {
      this.$http
        .postAccountCooperatorsList({ mobile: this.paramQueryTemp.mobile })
        .then(res => {
          if (res.statusCode === HTTP_CODE.suc) {
            this.resAccountCooperatorsList = res.data;
          }
        });
    },

    // 列表勾选
    handleSelectionChange(event) {
      this.tableSelectIdList = [];
      event.forEach(item => {
        this.tableSelectIdList.push(item.userId);
      });
    },

    // 批量更换手机号
    openModal() {
      // 判断是否勾选了
      if (this.tableSelectIdList.length == 0) {
        this.$confirm("请先勾选需要变更的账号", "提示", {
          type: "warning"
        });
        return false;
      }
      this.resDataInfo.oldPhoneNo = !checkNull(
        JSON.parse(getLocal("userMessage"))
      )
        ? JSON.parse(getLocal("userMessage")).phoneNo
        : this.$route.query.mobile;
      this.resDataInfo.num = this.tableSelectIdList.length;
      this.dialogVisible = true;
    },

    resetForm() {
      this.$refs.paramFormTempRef.resetFields();
      this.dialogVisible = false;
      !!this.timer && clearInterval(this.timer);
      this.getCode = "获取验证码";
      this.getCodeDisabled = false;
    },

    setIntervalTimer() {
      this.setTimeOutFun = setInterval(() => {
        this.dataTime--; //每秒减1
        if (this.dataTime === 0) {
          clearInterval(this.setTimeOutFun);
          //如果验证码倒计时到0 则停止倒计时 从新来
          this.dataTime = 3; //重置秒数
          this.paymentSubmitDialog = false;
          this.pathLogin();
        }
      }, 1000); //每秒减1
    },

    // 重新登陆
    pathLogin() {
      let param = {
        phoneNo: !checkNull(JSON.parse(getLocal("userMessage")))
          ? JSON.parse(getLocal("userMessage")).phoneNo
          : this.$route.query.mobile
      };
      this.$http.postBowOut(param).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.userMessage = {};
          this.$router.push({
            path: "/"
          });
          clearLocal();
          clearSession();
        }
      });
    },

    changeCompany(e) {
      this.paramQueryTemp.distributeCompanyId = e;
      this.clickQuery();
    },
    changeCooperator(e) {
      this.paramQueryTemp.cooperatorId = e;
      this.clickQuery();
    },
    clearParam(from) {
      if (from === "cooperatorId") {
        this.paramQueryTemp.cooperatorId = "";
      } else {
        this.paramQueryTemp.distributeCompanyId = "";
      }
      this.clickQuery();
    },

    // 换页
    handleCurrentChange(val) {
      this.paramQueryTemp.pageNum = val;
      this.clickQuery();
    },

    // 每页条数
    handleSizeChange(val) {
      this.paramQueryTemp.pageSize = val;
      this.clickQuery();
    }
  }
};
</script>

<style lang="scss">
#accTable .el-pagination {
  padding-top: 24px;
}

#accTable .el-table__row {
  height: 56px;
}
.query-item {
  .el-select {
    .el-input {
      width: 220px;
      .el-select__caret {
        line-height: 32px;
      }
    }
  }
}
#verificationCode .el-input {
  width: 150px;
}
</style>

<style lang="scss" scoped>
.select-acc-main {
  background: -webkit-linear-gradient(#2c32a5, #022955); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(#2c32a5, #022955); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(#2c32a5, #022955); /* Firefox 3.6 - 15 */
  background: linear-gradient(
    #2c32a5,
    #022955
  ); /* 标准的语法（必须放在最后） */
  height: 100%;
  width: 100%;
  min-height: 1000px;

  .select-acc-con {
    background-size: 100%;
    background-repeat: no-repeat;
    background-image: url("../../../static/selectAcc/pic_login_bg.png");
    padding: 69px 240px;
    background-size: 100%;
    height: 100%;

    .acc-box {
      background: #ffff;
      width: 960px;
      height: 900px;
      border-radius: 8px;
      margin: 0 auto;
      padding: 0 55px;

      .acc-box-img {
        width: 200px;
        height: 82px;
        margin: 0 auto;
        padding-top: 42px;
        display: block;
      }
      .acc-dec {
        // float: left;
        margin-top: 29px;
        font-size: 24px;
        margin-bottom: 24px;
        text-align: left;
        &::before {
          content: " ";
          width: 4px;
          margin-right: 8px;
          margin-top: 6px;
          height: 20px;
          border-radius: 4px;
          display: block;
          float: left;
          background: #1a85ff;
          clear: both;
        }
      }
    }
  }
}

.query-item {
  text-align: left;
  margin-bottom: 30px;
}

#accTable {
  height: 550px;
  overflow-y: scroll;
}
.flex_button {
  width: 100%;
  text-align: left;
  margin-bottom: 16px;
}
.subMitSucceed {
  height: 128px;
  margin-bottom: 19px;
  padding-left: 128px;
  background-color: #000;
  background: url(../../../static/batchData/picpoint_bg.png) left center
    no-repeat;
  .succeed-txt {
    margin-top: 24px;
    display: block;
    margin-bottom: 16px;
    font-family: MicrosoftYaHei;
    font-size: 24px;
    color: #13bf85;
    letter-spacing: 0;
    line-height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/selectAccount/selectAccount.vue